import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit';
import { ICascoLimitState, IOgpoVtsCars, IOgpoVtsClients } from '../types';

const initialState: ICascoLimitState = {
  beneficiary: null,
  car: null,
};

const cascoLimitSlice = createSlice({
  name: 'cascoLimitSlice',
  initialState,
  reducers: {
    reset: () => initialState,

    addBeneficiary: (
      state: Draft<ICascoLimitState>,
      action: PayloadAction<IOgpoVtsClients>
    ) => {
      state.beneficiary = action.payload;
    },

    addCar: (
      state: Draft<ICascoLimitState>,
      action: PayloadAction<IOgpoVtsCars>
    ) => {
      state.car = action.payload;
    },
  },
});

export const { reset, addBeneficiary } = cascoLimitSlice.actions;
export default cascoLimitSlice.reducer;
